module.exports = __webpack_public_path__ + "img/business-consult.421d3a2.png";